import React, { useMemo, useState } from "react";
import { Table, Button, Flex, Tooltip, Modal, Space, Empty } from "antd";
import {
  EditOutlined,
  SearchOutlined,
  DeleteOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";

import '../InvestorAdministrationTable/InvestorAdministrationTable.css'
import {axiosInstance} from "../../../../api/axiosInstance";
import { toast } from "react-toastify";

const InvestorAdministrationTable = ({
  userData,
  tableData,
  pageNumber,
  pageSize,
  totalRows,
  onFilterChanged,
  setMode,
  setInvestorAdministrationModalOpened,
  setRowData,
  refreshData,
}) => {

  console.log("USER DATA: ", userData);
  const [arrow, setArrow] = useState("Show");

  const [modal, contextHolder] = Modal.useModal();

  const isUserRole = userData?.authorities?.includes('ROLE_ZAPOSLENIK');

  const confirm = (id) => {
    modal.confirm({
      title: "Potvrda",
      icon: <ExclamationCircleOutlined />,
      content: "Jeste li sigurni da želite obrisati investitora?",
      okText: "Da",
      cancelText: "Ne",
      centered: true,
      onOk: () => {
        axiosInstance.delete(`/api/v1/investors/${id}`)
        .then(res => {
          toast.success("Investitor je uspješno obrisan!");
          refreshData();
        }).catch(ex => {
          toast.error(`${ex.response.data.errorMessage}`);
        })
      },
    });
  };

  const mergedArrow = useMemo(() => {
    if (arrow === "Hide") {
      return false;
    }

    if (arrow === "Show") {
      return true;
    }

    return {
      pointAtCenter: true,
    };
  }, [arrow]);

  const tableColumns = () => {
    return [
      {
        title: "Naziv",
        dataIndex: "name",
        key: "name",
        defaultSortOrder: "ascend",
        sortDirections: ['ascend', 'descend', 'ascend'],
        sorter: true,
      },
      {
        title: "OIB",
        dataIndex: "oib",
        key: "oib",
      },
      {
        title: "Adresa",
        dataIndex: "addressStr",
        key: "address",
      },
      {
        title: "Broj telefona",
        dataIndex: "phoneNumber",
        key: "phoneNumber",
      },
      {
        title: "Email",
        dataIndex: "email",
        key: "email",
      },
      {
        title: "",
        key: "operation",
        //fixed: "right",
        width: "150px",
        render: (text, record, index) => (
          <Flex vertical={false} gap={"4px"}>
            <Tooltip
              placement="top"
              title={<span>Pregled</span>}
              arrow={mergedArrow}
            >
              <Button
                type="text"
                size="large"
                icon={<SearchOutlined />}
                onClick={() => {
                  setMode("preview");
                  setRowData(record);
                  setInvestorAdministrationModalOpened(true);
                }}
              />
            </Tooltip>
            <Tooltip
              placement="top"
              title={<span>Uređivanje</span>}
              arrow={mergedArrow}
            >
              <Button
                type="text"
                size="large"
                icon={<EditOutlined />}
                onClick={() => {
                  setMode("edit");
                  setInvestorAdministrationModalOpened(true);
                  setRowData(record);
                }}
              />
            </Tooltip>
            <Tooltip
              placement="top"
              title={<span>Brisanje</span>}
              arrow={mergedArrow}
            >
              <Space>
                <Button
                  type="text"
                  size="large"
                  danger
                  icon={<DeleteOutlined />}
                  onClick={() => confirm(record.id)}
                  disabled={isUserRole}
                />
              </Space>
            </Tooltip>
          </Flex>
        ),
      },
    ];
  };

  return (
    <>
      <Table
        columns={tableColumns()}
        dataSource={tableData}
        onChange={(pagination, filters, sorter) =>
          onFilterChanged(pagination, filters, sorter)
        }
        style={{ marginTop: "32px"}}
        pageNumber={pageNumber}
        pageSize={pageSize}
        pagination={{ 
          defaultPageSize: 10, 
          showSizeChanger: true, 
          pageSizeOptions: ['10', '20', '30'], 
          total: totalRows, 
          showTotal: (total, range) =>  `Ukupan broj rezultata: ${totalRows}`
        }} 
        bordered
        scroll={{ x: 700 }}
        locale={{ emptyText:  <Empty description="Nije pronađen niti jedan investitor."/> }}
      />
      {contextHolder}
    </>
  );
};
export default InvestorAdministrationTable;
